import Endpoints from 'constants/Endpoints';
import {RestRequestGET} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'

const DEMAND_STATISTICS_RESOURCE_ID = 'demandStatistics';
const CURRENT_RFX_RESOURCE_ID = 'currentRfxRound';

const clearStats = () => {
    reduxStore.dispatch(clearResource(DEMAND_STATISTICS_RESOURCE_ID));

}

const getStats = async (demandId, roundId) => {
    try {
        const res = await RestRequestGET(Endpoints.STATISTIC(demandId, roundId));
        reduxStore.dispatch(setResource(DEMAND_STATISTICS_RESOURCE_ID, res));
    } catch (error) {
    }
}

const clearCurrentRound = () => {
    reduxStore.dispatch(clearResource(CURRENT_RFX_RESOURCE_ID));
}

const getCurrentRound = async (demandId) => {
    try {
        const res = await RestRequestGET(Endpoints.STATISTIC_CURRENT_ROUND(demandId));
        reduxStore.dispatch(setResource(CURRENT_RFX_RESOURCE_ID, res));
        return res;
    } catch (error) {
    }
}

export default {
    getStats,
    clearStats,
    getCurrentRound,
    clearCurrentRound,
    CURRENT_RFX_RESOURCE_ID,
    DEMAND_STATISTICS_RESOURCE_ID
}